module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms14x-popup-status",
      "id": "hrms14x-popup-status",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC2']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.codapp) + " - " + _vm._s(_vm.indexSelected.desc_codapp))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.desc_codempid))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.routeno))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateTimeOutput(_vm.indexSelected.dteinput)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC2']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.desc_staappr))])])])]), _vm._v(" "), (!_vm.popupStatusEditDisp) ? _c('hrms-table', {
    staticClass: "animated fadeIn",
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data,
      "editEvent": _vm.editEvent,
      "popupSelected": _vm.popupSelected,
      "id": "settime"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.popupStatusEditDisp) ? [_c('div', {
    staticClass: "hrms14x-popup-edit-box"
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.popupSelected.seqno))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS14XC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.popupSelected.typeapp))])])])]), _vm._v(" "), _c('hrms-table', {
    staticClass: "animated fadeIn",
    attrs: {
      "columns": _vm.columnsStatusEdit,
      "data": _vm.dataStatusEdit,
      "addInlineEventBool": true,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "saveInlineEvent": _vm.callSave,
      "popupSelected": _vm.popupSelected,
      "id": "settime",
      "backEvent": _vm.backEvent
    }
  })] : _vm._e()], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c0ee266!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms14x/popupStatus.vue
// module id = 3742
// module chunks = 1